// extracted by mini-css-extract-plugin
export default {"tabFilter":"styles_tabFilter__kfTU6"};